import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng';
import { Observable } from 'rxjs';
import { Anonyme } from 'src/app/entity/Anonyme';
import { Client } from 'src/app/entity/exhibitor';
import { FilterClient } from 'src/app/entity/Filter';
import { AuthenticationService } from 'src/app/service/authentication-service.service';
import { ContactService } from 'src/app/service/contact.service';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { ProspectService } from 'src/app/service/prospect.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-client-list-dialog',
  templateUrl: './client-list-dialog.component.html',
  styleUrls: ['./client-list-dialog.component.css']
})
export class ClientListDialogComponent implements OnInit {

  listArchives: Observable<Client[]>;
  @Input() index: number;

  cols: any[];
  types: any[];
  clients: Client[]
  loading: boolean;
url=environment.restApiAncienERP;

  @Input() visible: boolean;
  @Output() onHideDialog = new EventEmitter<any>();
  isArchive: boolean=true;
  actuelsProspects: Anonyme[];
  constructor(
    private exhibitorService: ExhibitorService,
    private contactService:ContactService,
    private authService:AuthenticationService,
    private prospectService: ProspectService,) {
    this.cols = [
      { field: 'raisonSocial', header: 'Raison Social', width: '40%' },
      { field: 'observation', header: 'Note', width: '30%' },
      { field: 'type', header: 'Type', width: '20%' },
      { field: 'dateEdit', header: 'MAJ', width: '10%' },
    ];
    this.types = [
      { label: 'Tout', value: "" },
  
      { label: 'Exposant Archivé', value: "AE" },
      { label: 'Co-Exposant Archivé', value: 'AC' },
      { label: 'Délégué Archivé', value: 'AD' },
      { label: 'Exposant Sponsor Archivé', value: 'AES' },
    ];
  }


  ngOnInit() {

  }
  convertType(t: string): string {
    let type: string=t;
    if (t == "AE")
      type = "Exposant Archivé"
    else if (t == "AES")
      type = "Exposant Sponsor Archivé"
    else if (t == "AC")
      type = "Co-Exposant Archivé"
    else if (t == "AD")
      type = "Délégué Archivé"

    else  if (t == "E")
      type = "Exposant"
    else if (t == "ES")
      type = "Exposant Sponsor"
    else if (t == "C")
      type = "Co-Exposant"
    else if (t == "D")
      type = "Délégué"
     
    return type;
  }


  getAll() {
    let filterClient = new FilterClient();
    filterClient.userId = 1
    filterClient.typeClient = "CLIENTS"
    this.exhibitorService.filterClientsAnonyme(filterClient).subscribe(data => {
      this.actuelsProspects=data;
      //console.log("end filter");
 this.onChange()
    });
  }

  findAllProspectsToImport( ) {





    this.prospectService.getAllClientAncienErp(this.url,this.isArchive).subscribe(result => {

      this.clients = []
     
     this.clients=  result.filter(e=> !this.actuelsProspects.map(e=>e.text1).includes(e.raisonSocial));
     /*
   result.forEach(elementErp => {
         
          let existe = false;
          data.forEach(element => {

            if (element['text1'] == elementErp.raisonSocial)
              existe = true


          });
          if (!existe)
            this.clients.push(elementErp)
       

        /// //console.log("this.staffs" + JSON.stringify(element));
      }); */
    
      
      this.visible = true

    })
  }
  async getClientAncienErp(client:Client) {
    this.prospectService.getClientAncienErp(this.url,client.idClient).subscribe(result=>{
      this.importerClient(result);
    })
  }


  async importerClient(client:Client) {
    client.pjointContrat=null;
    console.log("client ",client);
    
    let result = await this.exhibitorService.importerClient(client)

    result.subscribe(async result1 => {
        let client1: Client = result1;
         this.contactService.findContactsByProspectUrl(client.prospectId.prospectId,this.url).subscribe(async data => {
            console.log("contacts data",data);
         await   this.exhibitorService.importerContacts(data, client1).then(
           result=>{
             
           this.clients  =  this.clients.reduce((acc, curr) => {             
            if (curr.raisonSocial !== client.raisonSocial) acc.push(curr);
            return acc;
          }, []);
           }
         )
         
         
         .catch(e=>{

             // console.log("erroe",e);
                
            })

        })
   

 
        //console.log("resultresultresultresult ", result1);




    }

    )

}




  onShow() {

 this.authService.loginAncienERP(localStorage.getItem("username"),localStorage.getItem("password")).subscribe(result=>{
//console.log(localStorage.getItem("username"),localStorage.getItem("password"));

localStorage.setItem("tokenAncienERP",result.tokenpr)
//console.log("result.token",result.token);

  this.getAll()
 })






  }
  onHide() {
    this.onHideDialog.emit()

  }
  onChange(){
    this.  findAllProspectsToImport( )

if(this.isArchive)
    this.types = [
      { label: 'Tout', value: "" },
  
      { label: 'Exposant Archivé', value: "AE" },
      { label: 'Co-Exposant Archivé', value: 'AC' },
      { label: 'Délégué Archivé', value: 'AD' },
      { label: 'Exposant Sponsor Archivé', value: 'AES' },
    ];
    else 
    this.types = [
      { label: 'Tout', value: "" },
      
      { label: 'Exposant Archivé', value: "AE" },
      { label: 'Co-Exposant Archivé', value: 'AC' },
      { label: 'Délégué Archivé', value: 'AD' },
      { label: 'Exposant Sponsor Archivé', value: 'AES' },
    ];
    
  }
}
